// On load initialization
let variantIds_product = [];
let lastSavedStockState = "";

const soldOutWidget = document.querySelector('.getsitecontrol-inline-439414');
const productFormButtons = document.querySelector('product-form.product--add-to-cart-form');

const specialSizes = ["xs", "xl", "xxl"];

function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

function showWidget() {
  if(soldOutWidget) {
    soldOutWidget.classList.remove('hidden');
  }
  productFormButtons.classList.add('form--soldout');    
}

// function hasPreorderVariants() {
//   const preorderVariants = document.querySelectorAll('.limit_variant-main[data-variant*="Pre-order"]');
//    console.log('has preorder variants', preorderVariants.length > 0);
//   return preorderVariants.length > 0;
// }

function hasPreorderVariants() {
  // const variants = document.querySelectorAll('.limit_variant-main');
  // const hasPreorder = Array.from(variants).some(variant => {
  //   const metaValue = parseInt(variant.getAttribute('data-meta'), 10);
  //   return !isNaN(metaValue) && metaValue > 0;
  // });
  // console.log('has preorder variants', hasPreorder);
  // return hasPreorder;
  return false;
}

function checkSoldOutOrComingSoon() {
  const productTags = document.querySelectorAll(".product-tags div");
  let isComingSoon = false;
  let isSoldOut = false;
  let isPreOrderSoldOut = false;
  let isInStockSoldOut = false;
  let quantityTracked = true;

  const variantElement = document.querySelector(".limit_variant-main");
  if (variantElement) {
    quantityTracked = variantElement.getAttribute("data-tracks-inventory") === "shopify";
  }

  productTags.forEach((tag) => {
    const tagText = tag.textContent.trim().toLowerCase();
    if (tagText === "coming soon") isComingSoon = true;
    if (tagText === "sold out") isSoldOut = true;
    if (tagText === "pre-order sold out") isPreOrderSoldOut = true;
    if (tagText === "in-stock sold out") isInStockSoldOut = true;

    if(isSoldOut == true) {
    }
  });

  if (!quantityTracked || isComingSoon) {
    let productTitle = document.querySelector('.product-title').textContent;
    productTitle = productTitle.toLowerCase();
    // console.log(productTitle);
    if(productTitle.includes('gift card')) {
      // console.log('not executing if in here');
      return false;
    } else {
      document.getElementById("variant-loader").style.display = "none";
      document.getElementById("variant-picker").style.display = "block";
      const productForm = document.querySelector(".product--add-to-cart-form");
      if (productForm) productForm.style.display = "block";
      //change text to coming soon to be sure
      disableAddToCart("Coming Soon");
      return true;
    }
  }

  if (isSoldOut) {
    // console.log('here');
    document.getElementById("variant-loader").style.display = "none";
    document.getElementById("variant-picker").style.display = "block";
    const productForm = document.querySelector(".product--add-to-cart-form");
    if (productForm) productForm.style.display = "block";
    return true;
  }

  let preOrderVariantsSoldOut = checkAllSizesSoldOut("pre-order");
  let inStockVariantsSoldOut = checkAllSizesSoldOut("in-stock");

  if (isPreOrderSoldOut || preOrderVariantsSoldOut) {
    // console.log('here');
    disableStockStateSelectors("pre-order");
    // make sure to select an in-stock variant

    if(isPreOrderSoldOut) {
      forceSelectInStock();
    
      // Also select the first available in-stock size
      setTimeout(() => {
        // selectFirstAvailableInStock();
      }, 100); // Small delay to allow the UI to update
    }
  }

  if (isInStockSoldOut || inStockVariantsSoldOut) {
    // console.log('here');
    console.log('in stock sold out');
    disableStockStateSelectors("in-stock");
    // return true;
  }

  if (isInStockSoldOut && isPreOrderSoldOut) {
    // console.log('here');
    document.getElementById("variant-loader").style.display = "none";
    document.getElementById("variant-picker").style.display = "block";
    return true;
  }

  return false;
}

function checkPreOrderAvailable() {
  const preOrderVariants = document.querySelectorAll('.limit_variant-main[data-variant*="Pre-order"]');
  let anyPreOrderRemaining = false;
  preOrderVariants.forEach(variant => {
    const orderLimit = Number(variant.getAttribute("data-meta"));
    const limitInventory = Number(variant.getAttribute("data-inventory")) + orderLimit;
    if (limitInventory > 0) {
      anyPreOrderRemaining = true;
    }
  });
  return anyPreOrderRemaining;
}

function checkOnlySpecialSizesRemain(threshold = 3) {
  const inStockVariants = document.querySelectorAll('.limit_variant-main[data-variant*="In-stock"]');
  let totalInStockRemaining = 0;
  let totalInStockSpecial = 0;

  inStockVariants.forEach(variant => {
    const variantInventory = Number(variant.getAttribute("data-inventory")) + Number(variant.getAttribute("data-meta")) || 0;
    if (variantInventory > 0) {
      totalInStockRemaining += variantInventory;
      const variantText = variant.getAttribute("data-variant")?.toLowerCase() || "";
      const variantParts = variantText.split(" / ");
      const isSpecial = variantParts.some(part => specialSizes.includes(part));
      if (isSpecial) {
        totalInStockSpecial += variantInventory;
      }
    }
  });

  if (totalInStockRemaining > 0 && totalInStockRemaining <= threshold && totalInStockSpecial === totalInStockRemaining) {
    return true;
  }
  return false;
}

function shiftToPreOrderTab() {
  const firstPreOrderVariant = document.querySelector('.limit_variant-main[data-variant*="Pre-order"]');
  if (!firstPreOrderVariant) return;
  const preOrderVariantTitle = firstPreOrderVariant.getAttribute("data-variant");
  const labelToClick = document.querySelector(`.product-variant__item[data-variant-title="Pre-order"] input`);
  if (labelToClick) {
    labelToClick.click();
  }
}

function selectFirstAvailableSize() {
  const variantOptions = document.querySelectorAll('.limit_variant-main');
  let firstAvailableVariant = null;

  variantOptions.forEach(variant => {
    const limitInventory = Number(variant.getAttribute("data-inventory")) + Number(variant.getAttribute("data-meta"));
    const isDisabled = variant.querySelector("input")?.classList.contains("disabled");

    if (limitInventory > 0 && !isDisabled && !firstAvailableVariant) {
      firstAvailableVariant = variant;
    }
  });

  if (firstAvailableVariant) {
    const filterValueName = firstAvailableVariant.getAttribute('data-variant');
    const labelElement = document.querySelector(`.product-variant__item[data-variant-title='${filterValueName}'] label`);
    if (labelElement) {
      labelElement.click();
    }
  }
}

function selectFirstAvailableInStock() {
  // First try to find an available In-stock variant
  const inStockVariants = document.querySelectorAll('.limit_variant-main[data-variant*="In-stock"]');
  let firstAvailableInStock = null;

  // Look for the first available in-stock variant
  inStockVariants.forEach(variant => {
    const limitInventory = Number(variant.getAttribute("data-inventory")) + Number(variant.getAttribute("data-meta"));
    const isDisabled = variant.querySelector("input")?.classList.contains("disabled");

    if (limitInventory > 0 && !isDisabled && !firstAvailableInStock) {
      firstAvailableInStock = variant;
    }
  });

  // If we found an available in-stock variant, select it
  if (firstAvailableInStock) {
    const filterValueName = firstAvailableInStock.getAttribute('data-variant');
    const labelElement = document.querySelector(`.product-variant__item[data-variant-title='${filterValueName}'] label`);
    if (labelElement) {
      labelElement.click();
      return true; // Successfully selected an in-stock variant
    }
    // console.log('selected first available in stock');
  }

  // If no in-stock variants are available, fall back to any available variant
  return selectFirstAvailableSize(); // Use the original function as fallback
}

function forceSelectInStock() {
  // Directly click the "In-stock" shipping time option
  const inStockRadio = document.querySelector('.product-variant__item[data-variant-title="In-stock"] input');
  const inStockLabel = document.querySelector('.product-variant__item[data-variant-title="In-stock"] label');
  
  if (inStockLabel) {
    // console.log('Forcing selection of In-stock shipping option');
    // First try clicking the label which is more reliable for triggering events
    inStockLabel.click();
    return true;
  } else if (inStockRadio) {
    // console.log('Forcing selection of In-stock shipping option via input');
    inStockRadio.checked = true;
    // Dispatch change event to ensure the UI updates
    inStockRadio.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }
  
  return false;
}

function checkAllSizesSoldOut(stockState) {
  const variants = document.querySelectorAll(`.limit_variant-main[data-variant*='${capitalizeFirstLetter(stockState)}']`);
  let allSoldOut = true;

  variants.forEach((variant) => {
    const orderLimit = Number(variant.getAttribute("data-meta"));
    const limitInventory = Number(variant.getAttribute("data-inventory")) + orderLimit;
    if (limitInventory > 0) allSoldOut = false;
  });

  return allSoldOut;
}

function disableStockStateSelectors(stockState) {
  document
    .querySelectorAll(`.product-variant__item[data-variant-title='${capitalizeFirstLetter(stockState)}'] input`)
    .forEach((input) => {
      input.classList.add("disabled");
      // input.setAttribute("disabled", true);
    });

  document
    .querySelectorAll(`.product-variant__item[data-variant-title^='${capitalizeFirstLetter(stockState)}']`)
    .forEach((item) => {
      item.querySelectorAll(".product-variant-value").forEach((input) => {
        input.classList.add("disabled");
        // input.setAttribute("disabled", true);
      });
    });
}

function disableAllSelectors() {
  document.querySelectorAll(".product-variant__item input").forEach((input) => {
    input.classList.add("disabled");
    // input.setAttribute("disabled", true);
  });
  
  showWidget();
}

function disableAddToCart(message) {
  const addToCartText = document.querySelector(".add-to-cart__text");
  if (addToCartText) addToCartText.textContent = message;
  document.querySelector("#AddToCart-product")?.classList.add("disabled");
  showWidget();
}

function setAdd() {
  const addToCartText = document.querySelector(".add-to-cart__text");
  if (addToCartText) addToCartText.textContent = "add to cart";
  document.querySelector("#AddToCart-product")?.classList.remove("disabled");
  if(soldOutWidget) {
    soldOutWidget.classList.add("hidden");
  }
  productFormButtons.classList.remove('form--soldout');
}

function ProductQuantity() {
  const tagsIndicateSoldOut = checkSoldOutOrComingSoon();
  if (tagsIndicateSoldOut) {
    disableAddToCart("Sold Out");
    return;
  }

  const variantId = document.querySelector('[name="id"]')?.value;
  const variantElement = document.querySelector(`.limit_variant-main[data-id='${variantId}']`);
  if (!variantElement) return;

  const variantOption = variantElement.getAttribute("data-variant");
  const options = variantOption.toLowerCase().split(" / ");
  const stockState = options.find(option => option === "in-stock" || option === "pre-order");
  const hasPreorder = hasPreorderVariants();

  $(".limit_variant-main").each(function () {
    variantIds_product.push($(this).data("id"));
  });

  if (variantIds_product.length > 0) {
    $.ajax({
      type: "GET",
      url: "/cart.js",
      dataType: "JSON",
      success: function (data) {
        const items = data.items;

        variantIds_product.forEach(function (variantId) {
          processVariant(variantId, items, tagsIndicateSoldOut, hasPreorder);
        });

        if (!tagsIndicateSoldOut) {
          checkQuantity(hasPreorder);
        }
      },
    });
  }

  if (stockState) {
    disableSizeSelectors("pre-order");
    disableSizeSelectors("in-stock");
  }
}

function processVariant(variantId, cartItems, tagsIndicateSoldOut, hasPreorder) {
  const variantElement = document.querySelector(`.limit_variant-main[data-id="${variantId}"]`);
  if (!variantElement) return;

  const orderLimit = Number(variantElement.getAttribute("data-meta"));
  const productId = Number(variantElement.getAttribute("data-productid"));
  const limitInventoryOriginal = variantElement.getAttribute("data-inventory");
  let limitInventory = Number(variantElement.getAttribute("data-inventory")) + orderLimit;

  const tracksInventory = variantElement.getAttribute("data-tracks-inventory") === "shopify";
  const continueSelling = variantElement.getAttribute("data-continue-selling") === "continue";

  let itemsCount = 0;
  cartItems.forEach((item) => {
    if (productId === item.product_id && variantId === item.id) {
      itemsCount = item.quantity;
    }
  });

  if (!tracksInventory) {
    document.querySelector(`.product-variant__item[data-variant="${variantId}"] input`)?.classList.remove("disabled");
    console.log('here');
    setAdd();
    return;
  }

  if (hasPreorder && continueSelling) {
    const totalRequested = itemsCount + 1;
    if (totalRequested > orderLimit) {
      document.querySelector(`.product-variant__item[data-variant="${variantId}"] input`)?.classList.add("disabled");
      disableAddToCart("Pre-order Limit Reached");
    } else {
      document.querySelector(`.product-variant__item[data-variant="${variantId}"] input`)?.classList.remove("disabled");
      console.log('here');
      setAdd();
    }
  } else {
    const remainingInventory = limitInventory - itemsCount;
    if (remainingInventory <= 0) {
      document.querySelector(`.product-variant__item[data-variant="${variantId}"] input`)?.classList.add("disabled");
      disableAddToCart("Sold Out");
    } else {
      document.querySelector(`.product-variant__item[data-variant="${variantId}"] input`)?.classList.remove("disabled");
      console.log('here');
      setAdd();
    }
  }
}

function disableSizeSelectors(stockState) {
  const selectedStockStateElement = document.querySelector(
    `.product-variant__item[data-variant-title='${capitalizeFirstLetter(stockState)}'] input:checked`
  );

  if (selectedStockStateElement && selectedStockStateElement.classList.contains("disabled")) {
    document
      .querySelectorAll(`.product-variant__item[data-variant-title^='${capitalizeFirstLetter(stockState)}']`)
      .forEach((item) => {
        item.querySelectorAll(".product-variant-value").forEach((input) => {
          input.classList.add("disabled");
          // input.setAttribute("disabled", true);
        });
      });
  }

  showWidget();
}

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var CACHE_DURATION = 120000;
var lastCartUpdateTimestamp = 0;
var cachedCartData = null;

document.addEventListener('cart:updatecache', onCartUpdate);

function onCartUpdate() {
  localStorage.removeItem('cachedCartData');
  localStorage.removeItem('cartDataTimestamp');
}

async function checkQuantity(hasPreorder) {
  const tagsIndicateSoldOut = checkSoldOutOrComingSoon();
  if (tagsIndicateSoldOut) {
    disableAddToCart("Sold Out");
    return;
  }

  const variantId = document.querySelector('[name="id"]')?.value;
  const variantEl = document.querySelector(`.limit_variant-main[data-id="${variantId}"]`);
  if (!variantEl) return;

  const orderLimit = Number(variantEl.getAttribute("data-meta"));
  const productId = Number(variantEl.getAttribute("data-productid"));
  const limitInventoryAttr = variantEl.getAttribute("data-inventory");
  const tracksInventory = variantEl.getAttribute("data-tracks-inventory") === "shopify";
  const continueSelling = variantEl.getAttribute("data-continue-selling") === "continue";
  let limitInventory = Number(limitInventoryAttr);

  // console.log('has preorder', hasPreorder, 'continueselling', continueSelling);
  
  if (!tracksInventory) {
    console.log('here');
    setAdd();
    return;
  }

  if (hasPreorder && continueSelling) {
    await checkPreorderQuantity(variantId);
  } else {
    if (continueSelling && !limitInventory && limitInventory !== 0) {
      // setAdd();
      return;
    }

    await checkRegularQuantity(variantId, productId, orderLimit, limitInventory);
  }

  setTimeout(() => {
    document.getElementById('variant-loader').style.display = 'none';
    document.getElementById('variant-picker').style.display = 'block';
  }, 250);
  const productForm = document.querySelector('.product--add-to-cart-form');
  if (productForm) productForm.style.display = 'block';
}

async function checkPreorderQuantity(variantId) {
  try {
    // Get current cart data to check for existing items
    const cartData = await getCartData();
    let existingQuantity = 0;
    
    // Count how many of this item are already in the cart
    cartData.items.forEach((item) => {
      if (productId === item.product_id && variantId == item.id) {
        existingQuantity = item.quantity;
      }
    });

    // console.log('existing quantity is', existingQuantity);
    console.log('code is here and executing');
    
    // Total quantity = what's already in cart + 1 being added
    const totalQuantity = existingQuantity + 1;
    
    const response = await fetch('https://ca96haabp7.execute-api.eu-west-3.amazonaws.com/prod/validate-preorder', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ variantId, quantity: totalQuantity }),
    });
    const data = await response.json();
    if (data.success) {
      console.log('here');
      setAdd();
    } else {
      disableAddToCart(data.message || "Pre-order Limit Reached");
    }
  } catch (error) {
    console.error('Error:', error);
    console.log('here');
    setAdd(); // Fallback to allow adding to cart if server check fails
  }
}

async function checkRegularQuantity(variantId, productId, orderLimit, limitInventory) {
  try {
    const cartData = await getCartData();
    let inCartQuantity = 0;
    cartData.items.forEach((item) => {
      if (productId === item.product_id && variantId == item.id) {
        inCartQuantity = item.quantity;
      }
    });

    limitInventory += orderLimit;
    const remainingInventory = limitInventory - inCartQuantity;

    updateQuantityUI(remainingInventory, variantId);
  } catch (error) {
    console.error("Error checking quantity:", error);
    console.log('here');
    setAdd(); // Fallback to allow adding to cart if check fails
  }
}

function getCachedCartData() {
  const cachedData = localStorage.getItem('cachedCartData');
  const timestamp = localStorage.getItem('cartDataTimestamp');
  
  if (cachedData && timestamp) {
    const now = Date.now();
    if (now - parseInt(timestamp) < CACHE_DURATION) {
      return JSON.parse(cachedData);
    }
  }
  
  return null;
}

function setCachedCartData(data) {
  localStorage.setItem('cachedCartData', JSON.stringify(data));
  localStorage.setItem('cartDataTimestamp', Date.now().toString());
}

async function getCartData() {
  const cachedData = getCachedCartData();
  if (cachedData) {
    return cachedData;
  }
  
  try {
    const response = await fetch("/cart.js");
    const cartData = await response.json();
    setCachedCartData(cartData);
    return cartData;
  } catch (error) {
    console.error("Error fetching cart data:", error);
    throw error;
  }
}

function updateQuantityUI(remainingInventory, variantId) {
  // Get variant element and product tags
  const variantElement = document.querySelector(`.limit_variant-main[data-id="${variantId}"]`);
  if (!variantElement) return;

  const variantOption = variantElement.getAttribute("data-variant").toLowerCase();
  const isInStockVariant = variantOption.includes("in-stock");
  const isPreOrderVariant = variantOption.includes("pre-order");
  
  // Check for special sold out tags
  const productTags = document.querySelectorAll(".product-tags div");
  let hasInStockSoldOutTag = false;
  let hasPreOrderSoldOutTag = false;
  
  productTags.forEach(tag => {
    const tagText = tag.textContent.trim().toLowerCase();
    if (tagText === "in-stock sold out") hasInStockSoldOutTag = true;
    if (tagText === "pre-order sold out") hasPreOrderSoldOutTag = true;
  });

  // Force sold out if appropriate tag exists for this variant type
  if ((isInStockVariant && hasInStockSoldOutTag) || (isPreOrderVariant && hasPreOrderSoldOutTag)) {
    const addToCartText = document.querySelector(".add-to-cart__text");
    if (addToCartText) addToCartText.textContent = "sold out";
    document.querySelector("#AddToCart-product")?.classList.add("disabled");
    
    // Make sure the variant selector is disabled
    const variantInput = document.querySelector(`.product-variant__item[data-variant="${variantId}"] input`);
    if (variantInput) {
      variantInput.classList.add("disabled");
      // variantInput.setAttribute("disabled", true);
    }
    
    showWidget();
    return; // Exit early
  }
  
  if (remainingInventory <= 0) {
    const addToCartText = document.querySelector(".add-to-cart__text");
    
    if (addToCartText) addToCartText.textContent = "sold out";
    document.querySelector("#AddToCart-product")?.classList.add("disabled");

    document.querySelector(`.product-variant__item[data-variant="${variantId}"] input`)
      ?.classList.add("disabled");
    showWidget();
  } else {   
    console.log('here');
    setAdd();
    document.querySelector("#AddToCart-product")?.classList.remove("disabled");
    document.querySelector(`.product-variant__item[data-variant="${variantId}"] input`)
      ?.classList.remove("disabled");
  }
}

if (typeof ProductPage !== "function") {
  class ProductPage extends HTMLElement {
    constructor() {
      super();

      if (!this.hasAttribute("data-empty-product")) {
        this.productGallery = this.querySelector(".product-gallery");
        this.productSlider = this.querySelector("css-slider");

        // Set up thumbnails
        if (this.querySelector(".product-gallery__thumbnails .thumbnail")) {
          this.querySelectorAll(".product-gallery__thumbnails .thumbnail").forEach((elm, i) => {
            if (i == 0) elm.classList.add("active");
            elm.addEventListener("click", (e) => {
              if (this.productSlider && this.productSlider.sliderEnabled) {
                this.productSlider.changeSlide(e.currentTarget.dataset.index);
              } else {
                window.scrollTo({
                  top: this.productGallery
                    .querySelector(`.product-gallery-item[data-faux-index="${e.currentTarget.dataset.fauxIndex || e.currentTarget.dataset.index}"]`)
                    .offsetTop + this.offsetTop,
                  behavior: "smooth",
                });
                this.thumbnailNavigationHelper(e.currentTarget.dataset.fauxIndex);
              }
              this._pauseAllMedia();
            });
          });

          if (this.productSlider) {
            this.productSlider.addEventListener("change", (e) => {
              this.thumbnailNavigationHelper(e.target.index);
            });
          }
        }

        if (this.productSlider) {
          this.productSlider.addEventListener("change", (e) => {
            const currentItem = this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`);
            if (currentItem && currentItem.dataset.productMediaType == "model" && this.xrButton) {
              this.xrButton.setAttribute("data-shopify-model3d-id", currentItem.dataset.mediaId);
            }
            this._pauseAllMedia();
            this.thumbnailNavigationHelper(e.target.index);
          });
        }

        // Listen to variant changes
        const productVariants = this.querySelector("product-variants");
        if (productVariants) {
          this.debouncedVariantChangeHandler = debounce(this.onVariantChangeHandler.bind(this), 1);
          productVariants.addEventListener("VARIANT_CHANGE", this.debouncedVariantChangeHandler);
          this.debouncedVariantChangeHandler({ target: productVariants });
        }

        // Show cart drawer on add-to-cart
        if (!document.body.classList.contains("template-cart") && KROWN.settings.cart_action == "overlay") {
          let addToCartEnter = false;
          const addToCartBtn = this.querySelector(".product--add-to-cart-button");
          if (addToCartBtn) {
            addToCartBtn.addEventListener("keyup", (e) => {
              if (e.keyCode == window.KEYCODES.RETURN) {
                addToCartEnter = true;
              }
            });
          }

          const addToCartForm = this.querySelector(".product--add-to-cart-form");
          if (addToCartForm) {
            addToCartForm.addEventListener("add-to-cart", () => {
              checkQuantity(hasPreorderVariants());
              document.getElementById("site-cart").show();
              const cartRecs = document.getElementById("cart-recommendations");
              if (cartRecs) cartRecs.generateRecommendations();
              if (addToCartEnter) {
                setTimeout(() => {
                  document.querySelector("#site-cart .sidebar__cart-close")?.focus();
                }, 200);
              }
            });
          }
        }

        // Re-check quantities when cart sidebar is closed
        const overlay = document.querySelector(".site-overlay");
        if (overlay) {
          overlay.addEventListener("click", function () {
            checkQuantity(hasPreorderVariants());
          });
        }
        const sidebarCloseButton = document.querySelector(".site-close-handle");
        if (sidebarCloseButton) {
          sidebarCloseButton.addEventListener("click", function () {
            checkQuantity(hasPreorderVariants());
          });
        }

        // Scroll navigation helper for gallery style
        if (this.productGallery && this.productGallery.dataset.style == "scroll") {
          this.productGalleryNavigation = this.querySelector(".product-gallery__thumbnails");
          this.productGalleryNavigationItem = this.querySelectorAll(".product-gallery__thumbnails .thumbnail");
          const productGallerySlides = this.productGallery.querySelectorAll(".product-gallery-item");
          const reversedGallerySlides = [...productGallerySlides].reverse();

          const checkIfProductIsFirst = this.parentNode === document.querySelector("#main .mount-product-page:first-child")
            ? document.querySelector("#main .mount-product-page:first-child .product-gallery__thumbnails")
            : false;

          this.GALLERY_NAVIGATION_SCROLL = () => {
            if (!this.productGallery.querySelector("css-slider").sliderEnabled && window.innerWidth > 768) {
              for (const slide of reversedGallerySlides) {
                const slideTop = slide.getBoundingClientRect().top;
                if (slideTop < window.innerHeight / 2 && slideTop > -window.innerHeight / 2) {
                  this.productGalleryNavigationItem.forEach((elm) => elm.classList.remove("active"));
                  this.productGalleryNavigationItem[slide.dataset.fauxIndex].classList.add("active");
                  break;
                }
              }

              const productGalleryTop = this.productGallery.getBoundingClientRect().top;
              if ((productGalleryTop - window.innerHeight) * -1 > this.productGallery.offsetHeight) {
                this.productGalleryNavigation.classList.add("scroll");
                this.productGalleryNavigation.classList.remove("scroll-up");
              } else if (productGalleryTop > 0) {
                this.productGalleryNavigation.classList.add("scroll-up", "scroll");
                if (checkIfProductIsFirst) {
                  checkIfProductIsFirst.style.height = `calc(var(--window-height) + ${window.scrollY}px)`;
                }
              } else if ((productGalleryTop - window.innerHeight) * -1 < this.productGallery.offsetHeight) {
                this.productGalleryNavigation.classList.remove("scroll", "scroll-up");
              }
            }
          };

          window.addEventListener("scroll", this.GALLERY_NAVIGATION_SCROLL, { passive: true });
          this.GALLERY_NAVIGATION_SCROLL();
        }

        // 3D models
        const models = this.querySelectorAll("product-model");
        if (models.length > 0) {
          window.ProductModel.loadShopifyXR();
          this.xrButton = this.querySelector(".product__view-in-space");
        }

        // Adjust sticky positions
        const productContentBox = this.querySelector(".box__product-content");
        const productGalleryBox = this.querySelector(".box__product-gallery");

        this.CONTENT_STICKY_RESIZE = () => {
          productContentBox.style.top = `calc(100vh - ${productContentBox.offsetHeight + 1}px)`;
          productGalleryBox.style.top = `calc(100vh - ${productGalleryBox.offsetHeight + 1}px)`;
        };
        window.addEventListener("resize", this.CONTENT_STICKY_RESIZE, { passive: true });
        this.CONTENT_STICKY_RESIZE();

        const contentObserver = new MutationObserver(() => {
          this.CONTENT_STICKY_RESIZE();
        });
        contentObserver.observe(productContentBox, {
          attributes: true,
          childList: true,
          subtree: true,
        });

        // Video popups
        if (this.productGallery.querySelector("video-popup")) {
          const productVideoObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.target.classList.contains("video-opened")) {
                this.productGallery.classList.add("remove-navigation");
              } else {
                this.productGallery.classList.remove("remove-navigation");
              }
            });
          });
          this.productGallery.querySelectorAll("video-popup").forEach((elm) => {
            productVideoObserver.observe(elm, {
              attributes: true,
              childList: false,
              subtree: false,
            });
          });
        }
      }
    }

    preserveState() {
      const addToCartButton = document.querySelector("#AddToCart-product");
      const addToCartText = addToCartButton.querySelector(".add-to-cart__text");
      this.previousState = {
        buttonText: addToCartText.textContent,
        buttonDisabled: addToCartButton.classList.contains("disabled")
      };
    }

    restoreState() {
      const addToCartButton = document.querySelector("#AddToCart-product");
      const addToCartText = addToCartButton.querySelector(".add-to-cart__text");
      addToCartText.textContent = this.previousState.buttonText;
      if (this.previousState.buttonDisabled) {
        addToCartButton.classList.add("disabled");
      } else {
        addToCartButton.classList.remove("disabled");
      }
    }

    thumbnailNavigationHelper(index = 0) {
      this.querySelectorAll(".product-gallery__thumbnails .thumbnail").forEach((elm, i) => {
        if (i == index) elm.classList.add("active");
        else elm.classList.remove("active");
      });
    }

    onVariantChangeHandler(e) {
      this.preserveState();
      
      const variant = e.target.currentVariant;
      if (variant && variant.featured_media != null) {
        const variantImg = this.productGallery.querySelector(`.product-gallery-item[data-media-id="${variant.featured_media.id}"]`);
        if (variantImg) {
          if (this.productGallery.dataset.style == "slider" || 
             (this.productGallery.dataset.style == "scroll" && this.productGallery.querySelector("css-slider").sliderEnabled)) {
            this.productGallery.querySelector("css-slider").changeSlide(variantImg.dataset.index);
          } else {
            const originalOrder = [...this.productGallery.querySelectorAll(".product-gallery-item")]
              .sort((a, b) => a.dataset.index - b.dataset.index);

            if (Math.abs(this.productGallery.getBoundingClientRect().y) > window.innerHeight / 2) {
              window.scrollTo({ top: this.productGallery.offsetTop, behavior: "smooth" });
            }
            originalOrder.forEach((elm) => {
              this.productGallery.querySelector("css-slider").append(elm);
            });
            this.productGallery.querySelector("css-slider").prepend(variantImg);
            this.reorderThumbnailNavigation();
          }
        }
      }

      const variantId = document.querySelector('[name="id"]')?.value;
      if (!variantId) {
        this.restoreState();
        return;
      }

      const orderLimit = Number(document.querySelector(`.limit_variant-main[data-id="${variantId}"]`)?.getAttribute("data-meta") || 0);

      if (variant) {
        const newStockState = variant.option1.toLowerCase();
        const hasPreorder = hasPreorderVariants();

        if (checkSoldOutOrComingSoon()) {
          //check whether sold out or coming soon
          const productTags = document.querySelectorAll(".product-tags div");
          let isComingSoon = false;
          let isSoldOut = false;
        
          productTags.forEach((tag) => {
            const tagText = tag.textContent.trim().toLowerCase();
            if (tagText === "coming soon") isComingSoon = true;
            if (tagText === "sold out") isSoldOut = true;
          });

          if(isComingSoon) {
            disableAddToCart("Coming Soon");
          } else {
            disableAddToCart("Sold Out");
          }
        } else if (newStockState == "in-stock" || newStockState == "pre-order") {
          if (lastSavedStockState == "" || newStockState != lastSavedStockState) {
            ProductQuantity();
            lastSavedStockState = newStockState;
          } else {
            checkQuantity(hasPreorder);
          }
        } else {
          checkQuantity(hasPreorder);
        }
      } else {
        this.restoreState();
      }
    }

    reorderThumbnailNavigation() {
      const reversedGallerySlidesForThumbnails = [...this.productGallery.querySelectorAll(".product-gallery-item")].reverse();
      const galleryThumbnailsHolder = this.querySelector(".product-gallery__thumbnails .thumbnails-holder .thumbnails");
      reversedGallerySlidesForThumbnails.forEach((slide) => {
        galleryThumbnailsHolder.prepend(
          this.querySelector(`.product-gallery__thumbnails .thumbnail[data-faux-index="${slide.dataset.index}"]`)
        );
      });
      this.querySelectorAll(".product-gallery__thumbnails .thumbnails-holder .thumbnail").forEach((elm, i) => {
        elm.setAttribute("data-index", i);
      });
      this.thumbnailNavigationHelper(0);
      setTimeout(() => {
        this.thumbnailNavigationHelper(0);
      }, 10);
    }

    _pauseAllMedia() {
      document.querySelectorAll(".product .js-youtube").forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
      });
      document.querySelectorAll(".product .js-vimeo").forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', "*");
      });
      document.querySelectorAll(".product video").forEach((video) => video.pause());
      document.querySelectorAll(".product product-model").forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.pause();
      });
    }

    _playMedia(media) {
      switch (media.dataset.productMediaType) {
        case "video":
          media.querySelector("video").play();
          break;
        case "external_video-youtube":
          media.querySelector(".js-youtube").contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*");
          break;
        case "external_video-vimeo":
          media.querySelector(".js-vimeo").contentWindow.postMessage('{"method":"play"}', "*");
          break;
      }
    }
  }

  customElements.define("product-page", ProductPage);
}

// Initialize product state
async function initializeProductState() {
  const tagsIndicateSoldOut = checkSoldOutOrComingSoon();
  if (tagsIndicateSoldOut) {
    // console.log('tags indicate sold out');
    disableAllSelectors();
    return;
  }
  
  const variantId = document.querySelector('[name="id"]')?.value;
  const variantElement = document.querySelector(`.limit_variant-main[data-id='${variantId}']`);

  if (variantElement) {
    const quantityTracked = variantElement.getAttribute("data-tracks-inventory") === "shopify";
    const variantOption = variantElement.getAttribute("data-variant");
    const options = variantOption.toLowerCase().split(" / ");
    const stockState = options.find(option => option === "in-stock" || option === "pre-order");
    const hasPreorderLimit = Number(variantElement.getAttribute("data-meta")) > 0;

    // Show picker immediately for non-tracked inventory or regular in-stock products
    if (!quantityTracked || !hasPreorderLimit || (stockState === "in-stock" && !hasPreorderLimit)) {
      showPicker();
    } else {
    }
  }

  const loaderTimeout = setTimeout(() => {
    console.warn("Loader timeout reached. Displaying picker.");
    showPicker();
  }, 4000);

  try {
    const cartData = await getCartData(); // Use the cached getCartData function
    
    if (variantElement) {
      const quantityTracked = variantElement.getAttribute("data-tracks-inventory") === "shopify";
      const variantOption = variantElement.getAttribute("data-variant");
      const options = variantOption.toLowerCase().split(" / ");
      const stockState = options.find(option => option === "in-stock" || option === "pre-order");
      const hasPreorderLimit = Number(variantElement.getAttribute("data-meta")) > 0;

      if (quantityTracked && (stockState === "pre-order" || hasPreorderLimit)) {
        ProductQuantity(cartData.items);
        lastSavedStockState = stockState;
      } else {
        ProductQuantity(cartData.items);
        lastSavedStockState = "";
      }
    }

    selectFirstAvailableSize();
    
    if (checkOnlySpecialSizesRemain(3) && checkPreOrderAvailable()) {
      shiftToPreOrderTab();
    }

    clearTimeout(loaderTimeout);
  } catch (error) {
    console.error("Error fetching cart data on page load:", error);
    showPicker();
  }
}


function showPicker() {
  document.getElementById("variant-loader").style.display = "none";
  document.getElementById("variant-picker").style.display = "block";
  const productForm = document.querySelector(".product--add-to-cart-form");
  if (productForm) productForm.style.display = "block";
}

// Document ready function
$(document).ready(function () {
  const productTitle = document.querySelector(".product-title");
  if (productTitle && productTitle.textContent.toLowerCase().includes("suskicious")) {
    document.getElementById("variant-loader").style.display = "none";
    document.getElementById("variant-picker").style.display = "block";
    const productForm = document.querySelector(".product--add-to-cart-form");
    if (productForm) productForm.style.display = "block";
    return;
  }
  
  initializeProductState();
});
